import { createVNode as t, mergeProps as c } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SuccessTwoTone.js";
import m from "../components/PfIcon.js";
const o = (e, r) => {
  const s = {
    ...e,
    ...r.attrs
  };
  return t(m, c(s, {
    icon: n
  }), null);
};
o.displayName = "SuccessTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
